import axios, {AxiosResponse} from 'axios'

const api = '/api/general/'

const getCampuses = async () => {
  const response = await axios.get(`${api}get-campuses`)
  return response.data
}

// Start Impersonation
const startImpersonate = async ({data}) => {
  const response = await axios.post(`${api}start-impersonate`, data)
  return response.data
}

// Stop Impersonation
const stopImpersonate = async ({data}) => {
  const response = await axios.post(`${api}stop-impersonate`, data)
  return response.data
}

const getFaculties = async () => {
  const response = await axios.get(`${api}get-faculties`)
  return response.data
}

const notifications = async () => {
  const response = await axios.get(`${api}notifications`)
  return response.data
}

const readNotification = async (id: string) => {
  const response = await axios.get(`${api}read-notification/${id}`)
  return response.data
}

const getUniversities = async () => {
  const response = await axios.get(`${api}get-universities`)
  return response.data
}

const getSchools = async () => {
  const response = await axios.get(`${api}get-schools`)
  return response.data
}

const getSchoolSubjects = async () => {
  const response = await axios.get(`${api}get-school-subjects`)
  return response.data
}

const getSchoolClasses = async () => {
  const response = await axios.get(`${api}get-school-classes`)
  return response.data
}

const getKankorTerms = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${api}get-kankor-terms/${id}`)
  return response.data
}

const getSubjectTypes = async () => {
  const response = await axios.get(`${api}get-subject-types`)
  return response.data
}

const getSemesters = async () => {
  const response = await axios.get(`${api}get-semesters`)
  return response.data
}

const getAcademicRanks = async () => {
  const response = await axios.get(`${api}get-academic-ranks`)
  return response.data
}

const getSessions = async () => {
  const response = await axios.get(`${api}get-sessions`)
  return response.data
}

const getDays = async () => {
  const response = await axios.get(`${api}get-days`)
  return response.data
}

const getEducationDegrees = async () => {
  const response = await axios.get(`${api}get-educations-degree`)
  return response.data
}

const getPositions = async () => {
  const response = await axios.get(`${api}get-positions`)
  return response.data
}

const getSubjects = async () => {
  const response = await axios.get(`${api}get-subjects`)
  return response.data
}

const getLanguages = async () => {
  const response = await axios.get(`${api}get-languages`)
  return response.data
}

const getRelatives = async () => {
  const response = await axios.get(`${api}get-relatives`)
  return response.data
}

const getProvinces = async () => {
  const response = await axios.get(`${api}get-provinces`)
  return response.data
}

const getDistricts = async () => {
  const response = await axios.get(`${api}get-districts`)
  return response.data
}

const getNationalities = async () => {
  const response = await axios.get(`${api}get-nationalities`)
  return response.data
}

const generalService = {
  getSessions,
  getAcademicRanks,
  getSubjectTypes,
  getSemesters,
  getKankorTerms,
  getUniversities,
  getSchools,
  getSchoolSubjects,
  getSchoolClasses,
  readNotification,
  notifications,
  getCampuses,
  startImpersonate,
  stopImpersonate,
  getFaculties,
  getDays,
  getEducationDegrees,
  getPositions,
  getSubjects,
  getLanguages,
  getRelatives,
  getProvinces,
  getDistricts,
  getNationalities,
}

export default generalService
